module.exports = __webpack_public_path__ + "img/btn-golight.4779d134.png";